import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito equipamiento o ir a un gimnasio?',
  a: 'No. Todas las rutinas están diseñadas para hacerse en casa, con una colchoneta y tu propio peso corporal.'
}, {
  q: '¿Sirve para cualquier tipo de curvatura?',
  a: 'Sí. El Megapack incluye protocolos específicos para escoliosis, hipercifosis, hiperlordosis y rectificación cervical.'
}, {
  q: '¿Puedo usarlo si soy adolescente o si es para mi hijo?',
  a: 'Sí, hay rutinas y un bono específico para adolescentes en etapa de crecimiento.'
}, {
  q: '¿Reemplaza al kinesiólogo?',
  a: 'No reemplaza al profesional, lo complementa. Es lo que tu kinesiólogo te mandaría hacer entre sesiones, explicado paso a paso.'
}, {
  q: '¿Cuánto tiempo por día necesito?',
  a: 'Las rutinas van de 15 a 30 minutos. Con 20 minutos diarios el plan de 90 días funciona completo.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'Los primeros cambios en dolor y movilidad se notan entre la semana 2 y 4. Los cambios posturales visibles aparecen entre los 60 y 90 días con constancia.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Inmediatamente después del pago recibís un email con el acceso. Podés verlo desde el celular, tablet o computadora.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 30 días de garantía total. Te devolvemos el dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 bg-slate-50" data-id="element-110">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="text-center mb-10 md:mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-113">
            Preguntas frecuentes
          </h2>
          <div className="w-24 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-114"></div>
        </div>

        <div className="space-y-4" data-id="element-115">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-116">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-117">
                <span className="font-bold text-slate-900 pr-4" data-id="element-118">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-accent transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-119" />
              </button>
              <AnimatePresence data-id="element-120">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-121">
                    <div className="px-6 pb-5 text-slate-600" data-id="element-122">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}